module.exports = __webpack_public_path__ + "img/banner_pt.2b78a97b.jpg";